
import React from 'react';
import { ChevronsRight, Plus } from 'lucide-react';
import { SocialProfile } from './types';
import ProfileIcon from './ProfileIcon';
import { Button } from '@/components/ui/button';
import { SubscriptionGuard } from '@/components/subscription/SubscriptionGuard';

interface CollapsedSidebarProps {
  setIsCollapsed: (value: boolean) => void;
  isLoading: boolean;
  filteredProfiles: SocialProfile[];
  toggleProfileSelection: (id: string) => void;
  isSingleSelectionMode: boolean;
  singleSelectedProfile: string;
  selectedProfiles: string[];
  handlePageChange?: (page: string) => void;
  requireSubscription?: boolean;
  isSubscriptionActive?: boolean;
}

const CollapsedSidebar = ({
  setIsCollapsed,
  isLoading,
  filteredProfiles,
  toggleProfileSelection,
  isSingleSelectionMode,
  singleSelectedProfile,
  selectedProfiles,
  handlePageChange,
  requireSubscription = false,
  isSubscriptionActive = true
}: CollapsedSidebarProps) => {
  
  const AddProfileButton = () => (
    <button
      onClick={() => handlePageChange && handlePageChange('add-profile')}
      className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-600 dark:text-gray-400"
      aria-label="Ajouter un profil"
    >
      <Plus className="h-5 w-5" />
    </button>
  );
  
  return (
    <div className="h-full w-16 bg-white dark:bg-gray-800 border-r border-gray-100 dark:border-gray-700 flex flex-col items-center py-4">
      <button
        onClick={() => setIsCollapsed(false)}
        className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-500 dark:text-gray-400"
        aria-label="Étendre le panneau"
      >
        <ChevronsRight className="h-5 w-5" />
      </button>
      
      <div className="mt-6 w-full flex flex-col items-center space-y-4 overflow-y-auto">
        {!isLoading && filteredProfiles.map((profile) => (
          <button
            key={profile.id}
            onClick={() => {
              if (isSingleSelectionMode) {
                toggleProfileSelection(profile.id);
              } else {
                toggleProfileSelection(profile.id);
              }
            }}
            className={`relative p-2 rounded-full ${
              (isSingleSelectionMode && singleSelectedProfile === profile.id) || 
              (!isSingleSelectionMode && selectedProfiles.includes(profile.id))
                ? 'bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400'
                : 'hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-600 dark:text-gray-400'
            }`}
            aria-label={`Sélectionner ${profile.name}`}
          >
            <ProfileIcon platform={profile.platform} size="sm" />
          </button>
        ))}
      </div>
      
      {handlePageChange && (
        <div className="mt-6">
          {requireSubscription ? (
            <SubscriptionGuard>
              <AddProfileButton />
            </SubscriptionGuard>
          ) : (
            <AddProfileButton />
          )}
        </div>
      )}
    </div>
  );
};

export default CollapsedSidebar;
